import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { getTutorCategoryData, getTutorGroupCategoryData, getTutorGroupChildCategoryData, getTutorGroupSubCategoryData, getTutorOneCategoryData, getTutorOneChildCategoryData, getTutorOneSubCategoryData, getTutorStudyMaterialImageListData, getTutorStudyMaterialPdfListData, getTutorStudyMaterialVideoListData } from '../../../Redux/action/TutorAction';
import { getChildCategoryData, getSubCategoryData } from '../../../Redux/action/MasterAction';
import CropModal from "../../../utils/ImageCropModal";

const host = process.env.REACT_APP_API_SERVER
const TutorStudyMaterial = () => {
    const [filePreview, setFilePreview] = useState(null);
    const [fileName, setFileName] = useState("");
    const [showAddStudyMaterial, setshowAddStudyMaterial] = useState(true);
    const [showViewStudyMaterial, setshowViewStudyMaterial] = useState(false);

    const handleAddStudyMaterial = () => {
        setshowAddStudyMaterial(true);
        setshowViewStudyMaterial(false);
    }
    const handleViewStudyMaterial = () => {
        setshowAddStudyMaterial(false);
        setshowViewStudyMaterial(true);
    }


    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {

        dispatch(getTutorGroupCategoryData());
        dispatch(getTutorOneCategoryData());

    }, []);
    const {
        loadingTutorGroupCategoryDataListApi,
        TutorGroupCategoryDataListApiData,
        TutorGroupCategoryDataListApiError,

        loadingTutorGroupSubCategoryDataListApi,
        TutorGroupSubCategoryDataListApiData,
        TutorGroupSubCategoryDataListApiError,

        loadingTutorGroupChildCategoryDataListApi,
        TutorGroupChildCategoryDataListApiData,
        TutorGroupChildCategoryDataListApiError,


        //ONE TO ONE category
        loadingTutorOneCategoryDataListApi,
        TutorOneCategoryDataListApiData,
        TutorOneCategoryDataListApiError,


        //ONE TO ONE Subcategory
        loadingTutorOneSubCategoryDataListApi,
        TutorOneSubCategoryDataListApiData,
        TutorOneSubCategoryDataListApiError,

        loadingTutorOneChildCategoryDataListApi,
        TutorOneChildCategoryDataListApiData,
        TutorOneChildCategoryDataListApiError

    } = useSelector(state => state?.TutorReducer);







    const OneToOneformik = useFormik({
        initialValues: {
            category_id: "",
            sub_category_id: "",
            child_sub_category_id: "",
            teaching_type_id: "0",
            material_type: "",
            material_name: "",
            material_file: "",

        },
        validationSchema: Yup.object().shape({

            category_id: Yup.string().required("Class/Grade/General is required."),
            sub_category_id: Yup.string().required("Subject is required"),
            child_sub_category_id: Yup.string().required("Module is required."),
            material_type: Yup.string().required("Material Type is required"),
            material_name: Yup.string().required("Material Name is required."),
            material_file: Yup.string().required("File is required"),
            // material_file_video: Yup.string().required("File is required"),
            // material_file_pdf: Yup.string().required("File is required"),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);
                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('tutor-token'),
                        'Content-Type': 'multipart/form-data',
                    },
                };

                await axios.post(`${host}/api/tutor/study-material`, values, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success(response.data.message);
                            resetForm();


                        } else {

                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })

    const Groupformik = useFormik({
        initialValues: {
            category_id: "",
            sub_category_id: "",
            child_sub_category_id: "",
            teaching_type_id: "1",
            material_type: "",
            material_name: "",
            material_file: "",

        },
        validationSchema: Yup.object().shape({

            category_id: Yup.string().required("Class/Grade/General is required."),
            sub_category_id: Yup.string().required("Subject is required"),
            child_sub_category_id: Yup.string().required("Module is required."),
            material_type: Yup.string().required("Material Type is required"),
            material_name: Yup.string().required("Material Name is required."),
            material_file: Yup.string().required("File is required"),
            // material_file_video: Yup.string().required("File is required"),
            // material_file_pdf: Yup.string().required("File is required"),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);
                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('tutor-token'),
                        'Content-Type': 'multipart/form-data',
                    },
                };

                await axios.post(`${host}/api/tutor/study-material`, values, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success(response.data.message);
                            resetForm();


                        } else {

                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error(error.response.data.message);

                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })


    const ViewOneToOneformik = useFormik({
        initialValues: {
            category_id: null,
            sub_category_id: null,
            child_sub_category_id: null,
            teaching_type_id: "0",
            material_type: "video",
        },
        validationSchema: Yup.object().shape({
            category_id: Yup.string().required("Class/Grade/General is required."),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            const query = new URLSearchParams();
            query.append('teaching_type_id', 0)
            if (values.category_id) {
                query.append('category_id', values.category_id)
            }
            if (values.sub_category_id) {
                query.append('sub_category_id', values.sub_category_id)
            }

            if (values.child_sub_category_id) {
                query.append('child_sub_category_id', values.child_sub_category_id)
            }

            dispatch(getTutorStudyMaterialVideoListData(query.toString()))
            dispatch(getTutorStudyMaterialImageListData(query.toString()))
            dispatch(getTutorStudyMaterialPdfListData(query.toString()))
            navigate(`/tutor/view-study-material/${btoa(query.toString())}`);

        }
    })

    const ViewGroupformik = useFormik({
        initialValues: {
            category_id: null,
            sub_category_id: null,
            child_sub_category_id: null,
            teaching_type_id: "1",
            material_type: "video",
        },
        validationSchema: Yup.object().shape({
            category_id: Yup.string().required("Class/Grade/General is required."),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            const query = new URLSearchParams();
            query.append('teaching_type_id', 1)
            if (values.category_id) {
                query.append('category_id', values.category_id)
            }
            if (values.sub_category_id) {
                query.append('sub_category_id', values.sub_category_id)
            }

            if (values.child_sub_category_id) {
                query.append('child_sub_category_id', values.child_sub_category_id)
            }

            dispatch(getTutorStudyMaterialVideoListData(query.toString()))
            dispatch(getTutorStudyMaterialImageListData(query.toString()))
            dispatch(getTutorStudyMaterialPdfListData(query.toString()))
            navigate(`/tutor/view-study-material/${btoa(query.toString())}`);
        }
    })

    const handleGroupClassChange = (e) => {
        const id = e.target.value
        if (id == '') {
            dispatch(getTutorGroupSubCategoryData(0))
        }
        else {
            dispatch(getTutorGroupSubCategoryData(id))
        }
        Groupformik.setFieldValue('sub_category_id', '')
        Groupformik.setFieldValue('child_sub_category_id', '')

        dispatch(getTutorGroupChildCategoryData(Groupformik.values.category_id, 0))
    }


    const handleGroupSubjectChange = (e) => {
        const id = e.target.value
        Groupformik.setFieldValue('child_sub_category_id', '')
        dispatch(getTutorGroupChildCategoryData(Groupformik.values.category_id, id))
    }
    // useEffect(() => {

    //     dispatch(getTutorGroupSubCategoryData(Groupformik.values.category_id));

    // }, [Groupformik.values.category_id]);
    // useEffect(() => {

    //     dispatch(getTutorGroupChildCategoryData(Groupformik.values.category_id, Groupformik.values.sub_category_id));

    // }, [Groupformik.values.sub_category_id]);


    const handleOneClassChange = (e) => {
        const id = e.target.value
        OneToOneformik.setFieldValue('sub_category_id', '')
        OneToOneformik.setFieldValue('child_sub_category_id', '')

        if (id == '') {
            dispatch(getTutorOneSubCategoryData(0))
        }
        else {
            dispatch(getTutorOneSubCategoryData(id))
        }
        dispatch(getTutorOneChildCategoryData(0))
    }

    const handleOneSubjectChange = (e) => {
        const id = e.target.value
        if (id == '') {
            dispatch(getTutorOneChildCategoryData(0))
        }
        else {
            dispatch(getTutorOneChildCategoryData(OneToOneformik.values.category_id, id))
        }

    }
    // useEffect(() => {

    //     dispatch(getTutorOneSubCategoryData(OneToOneformik.values.category_id));

    // }, [OneToOneformik.values.category_id]);
    // useEffect(() => {

    //     dispatch(getTutorOneChildCategoryData(OneToOneformik.values.category_id, OneToOneformik.values.sub_category_id));

    // }, [OneToOneformik.values.sub_category_id]);

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

    const validateFile = (file, type) => {
        if (!file) return { valid: false, error: "No file selected" };

        // Validate type
        const fileType = file.type;
        if (type === "image" && !["image/jpeg", "image/png", "image/jpg"].includes(fileType)) {
            return { valid: false, error: "Only JPG, JPEG, PNG images are allowed." };
        }
        if (type === "pdf" && fileType !== "application/pdf") {
            return { valid: false, error: "Only PDF files are allowed." };
        }
        if (type === "video" && fileType !== "video/mp4") {
            return { valid: false, error: "Only MP4 videos are allowed." };
        }
        if (
            type === "ppt" &&
            ![
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation"
            ].includes(fileType)
        ) {
            return {
                valid: false,
                error: "Only PPT or PPTX files are allowed."
            };
        }

        if (
            type === "doc" &&
            ![
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ].includes(fileType)
        ) {
            return {
                valid: false,
                error: "Only DOC or DOCX files are allowed."
            };
        }

        // Validate size
        if (file.size > MAX_FILE_SIZE) {
            return { valid: false, error: "File size must be less than 10 MB." };
        }

        return { valid: true };
    };



    const [showCropModal, setShowCropModal] = useState(false);
    const [tempImageSrc, setTempImageSrc] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const materialType = OneToOneformik.values.material_type;

        const validation = validateFile(file, materialType);
        if (!validation.valid) {
            toast.error(validation.error);
            OneToOneformik.setFieldValue("material_file", null);
            setFilePreview(null);
            setFileName(null);
            return;
        }

        setFileName(file.name);

        if (materialType === "image") {
            const reader = new FileReader();
            reader.onloadend = () => {
                setTempImageSrc(reader.result);
                setShowCropModal(true); // open modal
            };
            reader.readAsDataURL(file);
        } else {
            OneToOneformik.setFieldValue("material_file", file);
            const reader = new FileReader();
            reader.onloadend = () => setFilePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // callback after cropping
    const handleCropComplete = (blob, fileUrl) => {
        const file = new File([blob], fileName, { type: "image/jpeg" });
        OneToOneformik.setFieldValue("material_file", file);
        setFilePreview(fileUrl);
        setShowCropModal(false);
    };





    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         // Set file name for PDFs
    //         setFileName(file.name);

    //         // Generate preview only for images and videos
    //         const fileType = file.type.split('/')[0]; // Get the file type (e.g., 'image', 'video')
    //         if (fileType === 'image' || fileType === 'video') {
    //             setFilePreview(URL.createObjectURL(file));
    //         } else {
    //             setFilePreview(null);
    //         }

    //         // Update Formik field value
    //         OneToOneformik.setFieldValue('material_file', file);
    //     }
    // };

    const [showGroupCropModal, setShowGroupCropModal] = useState(false);
    const [tempGroupImageSrc, setTempGroupImageSrc] = useState(null);

    const handleGroupFileChange = (e) => {
        const file = e.target.files[0];
        const materialType = Groupformik.values.material_type;

        const validation = validateFile(file, materialType);
        if (!validation.valid) {
            toast.error(validation.error);
            Groupformik.setFieldValue("material_file", null);
            setFilePreview(null);
            setFileName(null);
            return;
        }

        setFileName(file.name);

        if (materialType === "image") {
            const reader = new FileReader();
            reader.onloadend = () => {
                setTempGroupImageSrc(reader.result);
                setShowGroupCropModal(true); // open crop modal
            };
            reader.readAsDataURL(file);

            // Don't set Formik value yet; wait for crop
            Groupformik.setFieldValue("material_file", null);
            setFilePreview(null);
        } else {
            Groupformik.setFieldValue("material_file", file);
            const reader = new FileReader();
            reader.onloadend = () => setFilePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };
    const handleGroupCropComplete = (blob, fileUrl) => {
        const file = new File([blob], fileName, { type: "image/jpeg" });
        Groupformik.setFieldValue("material_file", file); // now valid
        setFilePreview(fileUrl);
        setShowGroupCropModal(false);
    };




    // const handleGroupFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         // Set file name for PDFs
    //         setFileName(file.name);

    //         // Generate preview only for images and videos
    //         const fileType = file.type.split('/')[0]; // Get the file type (e.g., 'image', 'video')
    //         if (fileType === 'image' || fileType === 'video') {
    //             setFilePreview(URL.createObjectURL(file));
    //         } else {
    //             setFilePreview(null);
    //         }



    //         // Update Formik field value
    //         Groupformik.setFieldValue('material_file', file);
    //     }
    // };


    // for view
    const handleViewGroupClassChange = (e) => {
        const id = e.target.value
        if (id === '') {
            dispatch(getTutorGroupSubCategoryData(0))
        }
        else {
            dispatch(getTutorGroupSubCategoryData(id))
        }
        ViewGroupformik.setFieldValue('sub_category_id', '')
        ViewGroupformik.setFieldValue('child_sub_category_id', '')

        dispatch(getTutorGroupChildCategoryData(ViewGroupformik.values.category_id, 0))
    }


    const handleViewGroupSubjectChange = (e) => {
        const id = e.target.value
        ViewGroupformik.setFieldValue('child_sub_category_id', '')
        if (id == '') {
            dispatch(getTutorGroupChildCategoryData(0))
        }
        else {
            dispatch(getTutorGroupChildCategoryData(ViewGroupformik.values.category_id, id))
        }

    }



    const handleViewOneClassChange = (e) => {
        const id = e.target.value
        if (id == '') {
            dispatch(getTutorOneSubCategoryData(0))
        }
        else {
            dispatch(getTutorOneSubCategoryData(id))
        }
        ViewOneToOneformik.setFieldValue('sub_category_id', '')
        ViewOneToOneformik.setFieldValue('child_sub_category_id', '')
        dispatch(getTutorOneChildCategoryData(0))
    }

    const handleViewOneSubjectChange = (e) => {
        const id = e.target.value
        ViewOneToOneformik.setFieldValue('child_sub_category_id', '')
        if (id == '') {
            dispatch(getTutorOneChildCategoryData(0))
        }
        else {
            dispatch(getTutorOneChildCategoryData(ViewOneToOneformik.values.category_id, id))
        }

    }


    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Study Material
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="study-material">
                                    <div className="row study-material-card-sec">
                                        <div className="col-lg-4 col-md-4 mb-3">
                                            <div className="card" id="add-study-tab" onClick={handleAddStudyMaterial}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-3 col-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9 col-9">
                                                            <h5 className="mb-0">Add Study Material</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 mb-3">
                                            <div className="card" id="view-study-tab" onClick={handleViewStudyMaterial}>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-3 col-md-3 col-3">
                                                            <div className="icon-sec">
                                                                <i className="bi bi-file-earmark-richtext" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9 col-9">
                                                            <h5 className="mb-0">View Study Material</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {showAddStudyMaterial && <div
                                        className="add-study-material-sec mt-5"
                                        id="add-study-tab-pane"

                                    >
                                        <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link active"
                                                    id="home-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#home"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="home"
                                                    aria-selected="true"
                                                >
                                                    One To One
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link"
                                                    id="profile-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#profile"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false"
                                                >
                                                    Group Tutoring
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="tab-content my-student-tab-pane" id="myTabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="home"
                                                role="tabpanel"
                                                aria-labelledby="home-tab"
                                            >
                                                <form method='post' onSubmit={OneToOneformik?.handleSubmit}>
                                                    <div className="row my-4">
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Class/Grade/General
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='category_id' onChange={(e) => {
                                                                OneToOneformik.handleChange(e);
                                                                handleOneClassChange(e);
                                                            }}
                                                                onBlur={OneToOneformik.handleBlur}
                                                                value={OneToOneformik.values.category_id}>
                                                                <option value=""> --Select Class--</option>
                                                                {TutorOneCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.category_id && OneToOneformik.errors.category_id ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Subject
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='sub_category_id' onChange={(e) => {
                                                                OneToOneformik.handleChange(e);
                                                                handleOneSubjectChange(e)
                                                            }}
                                                                onBlur={OneToOneformik.handleBlur}
                                                                value={OneToOneformik.values.sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorOneSubCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.sub_category_id && OneToOneformik.errors.sub_category_id ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.sub_category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label" >
                                                                Select Module
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='child_sub_category_id' onChange={(e) => {
                                                                OneToOneformik.handleChange(e);

                                                            }}
                                                                onBlur={OneToOneformik.handleBlur}
                                                                value={OneToOneformik.values.child_sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorOneChildCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.child_sub_category_id && OneToOneformik.errors.child_sub_category_id ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.child_sub_category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Material Type
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name="material_type"
                                                                onChange={(e) => {
                                                                    OneToOneformik.handleChange(e);
                                                                    OneToOneformik.setFieldValue("material_file", null);
                                                                    setFilePreview(null);
                                                                    setFileName(null);
                                                                }}
                                                                onBlur={OneToOneformik.handleBlur}
                                                                value={OneToOneformik.values.material_type}>
                                                                <option value="">-Select-</option>
                                                                <option value="image">Image</option>
                                                                <option value="video">Video</option>
                                                                <option value="pdf">Pdf</option>
                                                                <option value="ppt">PPT / PPTX</option>
                                                                <option value="doc">DOC / DOCX</option>
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.material_type && OneToOneformik.errors.material_type ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.material_type}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Material name
                                                            </label>
                                                            <br />
                                                            <input
                                                                type="text"
                                                                className="select-form"
                                                                placeholder="Enter material name"
                                                                name="material_name"
                                                                onChange={OneToOneformik.handleChange}
                                                                onBlur={OneToOneformik.handleBlur}
                                                                value={OneToOneformik.values.material_name}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.material_name && OneToOneformik.errors.material_name ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.material_name}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            {OneToOneformik?.values.material_type == 'image' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadImage"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadImage"
                                                                        type="file"
                                                                        accept="image/png, image/jpeg, image/jpg"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileChange}
                                                                        onBlur={OneToOneformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Image</h5>
                                                                </div>

                                                            )}
                                                            {/* Image upload buttons remain same */}

                                                            {/* Crop modal */}
                                                            {tempImageSrc && (
                                                                <CropModal
                                                                    isOpen={showCropModal}
                                                                    imageSrc={tempImageSrc}
                                                                    onCancel={() => setShowCropModal(false)}
                                                                    onCropComplete={handleCropComplete}
                                                                />
                                                            )}

                                                            {/* Image Preview */}
                                                            {/* {OneToOneformik?.values.material_type === 'image' && filePreview && (
                                                                <div className="image-preview mt-2">
                                                                    <img src={filePreview} alt="Preview" className="w-full rounded" />
                                                                </div>
                                                            )} */}


                                                            {OneToOneformik?.values.material_type == 'pdf' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadPdf"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadPdf"
                                                                        type="file"
                                                                        accept="application/pdf"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileChange}
                                                                        onBlur={OneToOneformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Pdf</h5>
                                                                </div>

                                                            )}

                                                            {OneToOneformik?.values.material_type == 'video' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadVideo"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadVideo"
                                                                        type="file"
                                                                        // accept="video/mp4"
                                                                        accept="video/mp4,video/quicktime,video/x-msvideo,video/webm"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileChange}
                                                                        onBlur={OneToOneformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Video</h5>
                                                                </div>

                                                            )}


                                                            {OneToOneformik?.values.material_type == 'ppt' && (
                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadPpt"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadPpt"
                                                                        type="file"
                                                                        accept=".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileChange}
                                                                        onBlur={OneToOneformik.handleBlur}
                                                                    />
                                                                    <h5>Upload PPT</h5>
                                                                </div>
                                                            )}

                                                            {OneToOneformik?.values.material_type == 'doc' && (
                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadDoc"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadDoc"
                                                                        type="file"
                                                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileChange}
                                                                        onBlur={OneToOneformik.handleBlur}
                                                                    />
                                                                    <h5>Upload DOC</h5>
                                                                </div>
                                                            )}
                                                            {/* Image Preview */}
                                                            {OneToOneformik?.values.material_type === 'image' && filePreview && (
                                                                <div className="image-preview mt-2">
                                                                    <img
                                                                        src={filePreview}
                                                                        alt="Preview"
                                                                        className="img-thumbnail"
                                                                        style={{ width: '200px', height: 'auto' }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Video Preview */}
                                                            {OneToOneformik?.values.material_type === 'video' && filePreview && (
                                                                <video width="200" height="150" controls>
                                                                    <source src={filePreview} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            )}

                                                            {/* PDF Preview (File Name Only) */}
                                                            {OneToOneformik?.values.material_type === 'pdf' && fileName && (
                                                                <div className="pdf-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}

                                                            {OneToOneformik?.values.material_type === 'ppt' && fileName && (
                                                                <div className="ppt-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}

                                                            {OneToOneformik?.values.material_type === 'doc' && fileName && (
                                                                <div className="doc-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            <div className="help-block with-errors">
                                                                {OneToOneformik.touched.material_file && OneToOneformik.errors.material_file ? (
                                                                    <div className='text-danger'>{OneToOneformik.errors.material_file}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            {/* <Link to="/tutor/add-study-material"> */}
                                                            <input
                                                                disabled={OneToOneformik.isSubmitting}
                                                                type="submit"
                                                                // defaultValue="submit"
                                                                value="Submit"
                                                                className="btn btn-primary srch-btn w-100"
                                                            />
                                                            {/* </Link> */}
                                                        </div>
                                                    </div>

                                                </form>
                                            </div>
                                            <div
                                                className="tab-pane fade"
                                                id="profile"
                                                role="tabpanel"
                                                aria-labelledby="profile-tab"
                                            >
                                                <form method='post' onSubmit={Groupformik?.handleSubmit}>
                                                    <div className="row my-4">
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Class/Grade/General
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='category_id' onChange={(e) => {
                                                                Groupformik.handleChange(e);
                                                                handleGroupClassChange(e);
                                                            }}
                                                                onBlur={Groupformik.handleBlur}
                                                                value={Groupformik.values.category_id}>
                                                                <option value=""> --Select Class--</option>
                                                                {TutorGroupCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.category_id && Groupformik.errors.category_id ? (
                                                                    <div className='text-danger'>{Groupformik.errors.category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Subject
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='sub_category_id' onChange={(e) => {
                                                                Groupformik.handleChange(e);
                                                                handleGroupSubjectChange(e)
                                                            }}
                                                                onBlur={Groupformik.handleBlur}
                                                                value={Groupformik.values.sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorGroupSubCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.sub_category_id && Groupformik.errors.sub_category_id ? (
                                                                    <div className='text-danger'>{Groupformik.errors.sub_category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label" >
                                                                Select Module
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='child_sub_category_id' onChange={(e) => {
                                                                Groupformik.handleChange(e);

                                                            }}
                                                                onBlur={Groupformik.handleBlur}
                                                                value={Groupformik.values.child_sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorGroupChildCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.child_sub_category_id && Groupformik.errors.child_sub_category_id ? (
                                                                    <div className='text-danger'>{Groupformik.errors.child_sub_category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Material Type
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name="material_type"
                                                                onChange={(e) => {
                                                                    Groupformik.handleChange(e);
                                                                    Groupformik.setFieldValue("material_file", null);
                                                                    setFilePreview(null);
                                                                    setFileName(null);
                                                                }}
                                                                onBlur={Groupformik.handleBlur}
                                                                value={Groupformik.values.material_type}>
                                                                <option value="">-Select-</option>
                                                                <option value="image">Image</option>
                                                                <option value="video">Video</option>
                                                                <option value="pdf">Pdf</option>
                                                                <option value="ppt">PPT / PPTX</option>
                                                                <option value="doc">DOC / DOCX</option>
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.material_type && Groupformik.errors.material_type ? (
                                                                    <div className='text-danger'>{Groupformik.errors.material_type}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Material name
                                                            </label>
                                                            <br />
                                                            <input
                                                                type="text"
                                                                className="select-form"
                                                                placeholder="Enter material name"
                                                                name="material_name"
                                                                onChange={Groupformik.handleChange}
                                                                onBlur={Groupformik.handleBlur}
                                                                value={Groupformik.values.material_name}
                                                            />
                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.material_name && Groupformik.errors.material_name ? (
                                                                    <div className='text-danger'>{Groupformik.errors.material_name}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            {Groupformik?.values.material_type == 'image' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadImage"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadImage"
                                                                        type="file"
                                                                        accept="image/png, image/jpeg, image/jpg"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleGroupFileChange}
                                                                        onBlur={Groupformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Image</h5>
                                                                </div>

                                                            )}
                                                            {showGroupCropModal && tempGroupImageSrc && (
                                                                <CropModal
                                                                    isOpen={showGroupCropModal}
                                                                    imageSrc={tempGroupImageSrc}
                                                                    onCancel={() => setShowGroupCropModal(false)}
                                                                    onCropComplete={handleGroupCropComplete}
                                                                />
                                                            )}


                                                            {Groupformik?.values.material_type == 'pdf' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadPdf"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadPdf"
                                                                        type="file"
                                                                        accept="application/pdf"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleGroupFileChange}
                                                                        onBlur={Groupformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Pdf</h5>
                                                                </div>

                                                            )}

                                                            {Groupformik?.values.material_type == 'video' && (

                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadVideo"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadVideo"
                                                                        type="file"
                                                                        // accept="video/mp4"
                                                                        accept="video/mp4,video/quicktime,video/x-msvideo,video/webm"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleGroupFileChange}
                                                                        onBlur={Groupformik.handleBlur}
                                                                    />
                                                                    <h5>Upload Video</h5>
                                                                </div>

                                                            )}

                                                            {Groupformik?.values.material_type == 'ppt' && (
                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadPptGroup"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadPptGroup"
                                                                        type="file"
                                                                        accept=".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleGroupFileChange}
                                                                        onBlur={Groupformik.handleBlur}
                                                                    />
                                                                    <h5>Upload PPT/PPTX</h5>
                                                                </div>
                                                            )}

                                                            {Groupformik?.values.material_type == 'doc' && (
                                                                <div className="upload-icon-sec">
                                                                    <label
                                                                        htmlFor="uploadDocGroup"
                                                                        style={{
                                                                            backgroundColor: "aliceblue",
                                                                            border: "1px solid",
                                                                            borderRadius: "50%",
                                                                            cursor: "pointer",
                                                                            display: "inline-block",
                                                                            padding: "1rem"
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-upload" />
                                                                    </label>
                                                                    <input
                                                                        id="uploadDocGroup"
                                                                        type="file"
                                                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                                        style={{ display: "none" }}
                                                                        onChange={handleGroupFileChange}
                                                                        onBlur={Groupformik.handleBlur}
                                                                    />
                                                                    <h5>Upload DOC/DOCX</h5>
                                                                </div>
                                                            )}


                                                            {/* Image Preview */}
                                                            {Groupformik?.values.material_type === 'image' && filePreview && (
                                                                <div className="image-preview mt-2">
                                                                    <img
                                                                        src={filePreview}
                                                                        alt="Preview"
                                                                        className="img-thumbnail"
                                                                        style={{ width: '200px', height: 'auto' }}
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Video Preview */}
                                                            {Groupformik?.values.material_type === 'video' && filePreview && (
                                                                <video width="200" height="150" controls>
                                                                    <source src={filePreview} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            )}

                                                            {/* PDF Preview (File Name Only) */}
                                                            {Groupformik?.values.material_type === 'pdf' && fileName && (
                                                                <div className="pdf-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}
                                                            {Groupformik?.values.material_type === 'ppt' && fileName && (
                                                                <div className="ppt-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}

                                                            {Groupformik?.values.material_type === 'doc' && fileName && (
                                                                <div className="doc-preview mt-2">
                                                                    <p>
                                                                        <strong>Selected File:</strong> {fileName}
                                                                    </p>
                                                                </div>
                                                            )}


                                                            <div className="help-block with-errors">
                                                                {Groupformik.touched.material_file && Groupformik.errors.material_file ? (
                                                                    <div className='text-danger'>{Groupformik.errors.material_file}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            {/* <Link to="/tutor/add-study-material"> */}
                                                            <input
                                                                disabled={Groupformik.isSubmitting}
                                                                type="submit"
                                                                // defaultValue="submit"
                                                                value="Submit"
                                                                className="btn btn-primary srch-btn w-100"
                                                            />
                                                            {/* </Link> */}
                                                        </div>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                    </div>}
                                    {showViewStudyMaterial && <div
                                        className="view-study-material-sec mt-5"
                                        id="view-study-tab-pane"

                                    >
                                        <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link active"
                                                    id="home-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#home"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="home"
                                                    aria-selected="true"
                                                >
                                                    One To One
                                                </button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button
                                                    className="nav-link"
                                                    id="profile-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#profile"
                                                    type="button"
                                                    role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false"
                                                >
                                                    Group Tutoring
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="tab-content my-student-tab-pane" id="myTabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="home"
                                                role="tabpanel"
                                                aria-labelledby="home-tab"
                                            >
                                                <form onSubmit={ViewOneToOneformik.handleSubmit}>
                                                    <div className="row my-4">
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Class/Grade/General
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='category_id' onChange={(e) => {
                                                                ViewOneToOneformik.handleChange(e);
                                                                handleViewOneClassChange(e);
                                                            }}
                                                                onBlur={ViewOneToOneformik.handleBlur}
                                                                value={ViewOneToOneformik.values.category_id}>
                                                                <option value=""> --Select Class--</option>
                                                                {TutorOneCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {ViewOneToOneformik.touched.category_id && ViewOneToOneformik.errors.category_id ? (
                                                                    <div className='text-danger'>{ViewOneToOneformik.errors.category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Subject
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='sub_category_id' onChange={(e) => {
                                                                ViewOneToOneformik.handleChange(e);
                                                                handleViewOneSubjectChange(e)
                                                            }}
                                                                onBlur={ViewOneToOneformik.handleBlur}
                                                                value={ViewOneToOneformik.values.sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorOneSubCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Module
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='child_sub_category_id' onChange={(e) => {
                                                                ViewOneToOneformik.handleChange(e);

                                                            }}
                                                                onBlur={ViewOneToOneformik.handleBlur}
                                                                value={ViewOneToOneformik.values.child_sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorOneChildCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-2">

                                                            <input
                                                                disabled={ViewOneToOneformik.isSubmitting}
                                                                type="submit"
                                                                // defaultValue="submit"
                                                                value="Submit"
                                                                className="btn btn-primary submit-btn mt-0 w-100"
                                                            />

                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div
                                                className="tab-pane fade"
                                                id="profile"
                                                role="tabpanel"
                                                aria-labelledby="profile-tab"
                                            >
                                                <form onSubmit={ViewGroupformik.handleSubmit}>
                                                    <div className="row my-4">
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Class/Grade/General
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='category_id' onChange={(e) => {
                                                                ViewGroupformik.handleChange(e);
                                                                handleViewGroupClassChange(e);
                                                            }}
                                                                onBlur={ViewGroupformik.handleBlur}
                                                                value={ViewGroupformik.values.category_id}>
                                                                <option value=""> --Select Class--</option>
                                                                {TutorGroupCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                            <div className="help-block with-errors">
                                                                {ViewGroupformik.touched.category_id && ViewGroupformik.errors.category_id ? (
                                                                    <div className='text-danger'>{ViewGroupformik.errors.category_id}</div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Subject
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='sub_category_id' onChange={(e) => {
                                                                ViewGroupformik.handleChange(e);
                                                                handleViewGroupSubjectChange(e)
                                                            }}
                                                                onBlur={ViewGroupformik.handleBlur}
                                                                value={ViewGroupformik.values.sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorGroupSubCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6">
                                                            <label htmlFor="" className="label">
                                                                Select Module
                                                            </label>
                                                            <br />
                                                            <select className="select-form" name='child_sub_category_id' onChange={(e) => {
                                                                ViewGroupformik.handleChange(e);

                                                            }}
                                                                onBlur={ViewGroupformik.handleBlur}
                                                                value={ViewGroupformik.values.child_sub_category_id}>
                                                                <option value="">
                                                                    --Select Subject--
                                                                </option>
                                                                {TutorGroupChildCategoryDataListApiData?.map((data) => (
                                                                    <option value={data?.id}>{data?.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            {/* <Link to="/tutor/view-study-material"> */}
                                                            <input
                                                                disabled={ViewGroupformik.isSubmitting}
                                                                type="submit"
                                                                // defaultValue="submit"
                                                                value="Submit"
                                                                className="btn btn-primary submit-btn mt-0 w-100"
                                                            />
                                                            {/* </Link> */}
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </main>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default TutorStudyMaterial